import { render, staticRenderFns } from "./checkPrice.vue?vue&type=template&id=ff715130&scoped=true"
import script from "./checkPrice.vue?vue&type=script&lang=js"
export * from "./checkPrice.vue?vue&type=script&lang=js"
import style0 from "./checkPrice.vue?vue&type=style&index=0&id=ff715130&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff715130",
  null
  
)

export default component.exports